<template>
  <div
    :class="{ hoverGroup: hover }"
    class="d-flex align-items-center justify-content-center"
    style="position:relative;"
  >
    <!--<div @click.stop class="cerchio d-flex align-items-center justify-content-center">
    <i
      @click.stop="hover = ! hover"
      class="fas fa-ellipsis-v"
      style="color:#a1a3a5; font-size:2vw;"
    ></i>
    </div>-->
    <button class="editButton secondaryButton" @click.stop="editRow()">
      <i class="fas fa-pencil-alt"></i>
    </button>
    <button class="deleteButton secondaryButton" @click.stop="deleteRow()">
      <i class="fas fa-trash"></i>
    </button>
  </div>
</template>

<script>
import { ref } from "@/components/puntatori";
import { EventBus } from "../main.js";
import Vue from "vue";
//i pulsanti azioni devono essere un componente a se stante
//header componente ??
//riga componente ? in futuro magari ?

export default {
  name: "crudTableActionButton",
  directives: {},
  props: ["config","trItem"],
  data() {
    return {
      elementType: "row",
      hover: false
    };
  },
  computed: {},
  methods: {
    editRow() {
      var obj = this.trItem;
      if (obj.id !== undefined) {
        this.$router.push(this.$route.path + "?id=" + obj.id);
        EventBus.$emit("stato_tendina", true);
      } else console.log(this.$options.name + "-" + "key non definita");
    },
    deleteRow() {
      var self = this;
      var obj = this.trItem;
      Vue.swal
        .fire({
          title: "Vuoi davvero cancellare?",
          text: "Modifica definitiva non potrai tornare indietro!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si, cancella!"
        })
        .then(result => {
          if (result.value) {
            ref[this.config.source].child(obj.id).remove();
            Vue.swal.fire(
              "Cacellato!",
              "L'elemento è stato eliminato con successo.",
              "success"
            );
          }
        });
    }
  },
  mounted() {},
  watch: {}
};
</script>

<style scoped>
.cerchio {
  background-color: #f8f8f8;
  padding: 10px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  width: 6vh;
  height: 6vh;
  text-align: center;
  opacity: 0.7;
}

button {
  position: relative;
  margin-left: 0.5vw;
  cursor: pointer;
  width: 2.5vw;
  height: 2.5vw;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border: none;

  color: white;
  background-color: #f7f7f7;
  -webkit-transition: all 500ms;
  -moz-transition: all 500ms;
  -o-transition: all 500ms;
  transition: all 500ms;
}

.deleteButton:hover {
  background-color: #c0392b;
}

.deleteButton {
  color: white;
}

.editButton:hover {
  background-color: #f1c40f;
}

.hoverGroup {
  -webkit-transition-timing-function: ease;
  transition-timing-function: ease;
}

.hover {
  opacity: 1;
}

button:focus {
  outline: none;
}
</style>
